import { useState, useEffect, useCallback, useRef, PropsWithChildren } from 'react';

import { Typography } from 'antd';

import { useAppSelector } from '@/hooks/redux';
import styled, { StyledProp } from '@/styled';

const WaterMark = (props: PropsWithChildren<StyledProp>) => {
  const [direction, setDirection] = useState({
    top: 100,
    left: 100
  });
  const container = useRef<HTMLDivElement>();
  const content = useRef<HTMLDivElement>();
  const user = useAppSelector(({ auth }) => auth.user);

  const randomPosition = useCallback(() => {
    if (!container.current) {
      return;
    }

    setDirection({
      top: Math.floor(Math.random() * (container.current.offsetHeight - content.current.offsetHeight) + 1),
      left: Math.floor(Math.random() * container.current.offsetWidth + 1)
    });

    const timeout = setTimeout(() => {
      setDirection(null);
      clearTimeout(timeout);
      const innerTimeout = setTimeout(() => {
        randomPosition();
        clearTimeout(innerTimeout);
      }, 60_000);
    }, 5_000);
  }, []);

  useEffect(() => {
    randomPosition();
  }, [randomPosition]);
  return (
    <div className={props.className} ref={container}>
      {props.children}
      <div
        ref={content}
        className={'container'}
        style={{
          ...direction,
          visibility: direction !== null ? 'visible' : 'hidden'
        }}
      >
        <Typography.Text>{user?.name}</Typography.Text>
        <Typography.Text>{user?.email}</Typography.Text>
      </div>
    </div>
  );
};

export default styled(WaterMark)`
  overflow: hidden;
  position: relative;

  .container {
    position: absolute;
  }
`;
